import Rank from './Rank';
import Connection from './Connection';
import Item from './Item';
import { getLoadingBarTpl } from '../../model/tpl/loadingbar';
import { BREAKPOINTS } from '../../model/model';
import { getDatasWithOption, handleApiError } from '../../utils/service';
import { isDefined, isRc, truthy, anyOf } from '../../utils/util';

class My {
  constructor(options) {
    const _ = this;

    if (!options) return;

    _.option = $.extend({
      wrap: null,
      apiDomain: '',
      userData: null,
      global: window
    }, options);

    _.wrap = _.option.wrap;

    _.rank = null;
    _.connection = null;
    _.item = null;

    _.slickWrap = $('#mySectionRoll', this.wrap);

    _.tpl = {
      CREATE_CHARACTER: function(_isRc) {
        const rcStr = truthy(_isRc) ? 'rc-' : '',
          url = `https://${rcStr}lineage.plaync.com/powerbook/wiki/%EC%BA%90%EB%A6%AD%ED%84%B0+%EC%83%9D%EC%84%B1`;

        return `<div class="nodata">
                  <p>게임에 접속해 캐릭터를 생성하시면<br /> 다양한 기능을 이용하실 수 있습니다.</p>
                  <a href="${url}">캐릭터 생성</a>
                </div>`
      },

      SET_REPRESENTATIVE_CHARACTER: `<div class="nodata">
                                      <p>대표 캐릭터를 설정하시면<br /> 다양한 기능을 이용하실 수 있습니다.</p>
                                      <a href="#" onclick="cnb.openCharacterPan(); window.cnbCharacterChange(); return;">대표 캐릭터 설정</a>
                                    </div>`,

      RETRY_LATER: `<div class="nodata">잠시 후 다시 시도해주세요.</div>`
    };
  }

  init() {
    const _ = this;

    if (isDefined(_.option.wrap) && _.option.wrap.length) {
      _.setInstance();
    }

    return _;
  }

  setInstance() {
    const _ = this;

    const account = (isDefined(_.option.userData)) ? _.option.userData.gameAccount : null,
      name = (isDefined(account)) ? account.name.trim() : '';
      // serverId = (isDefined(account)) ? account.serverId.trim() : '';

    if (anyOf(!name)) {
      // no character. or no representative character.

      const mySectionRoll = $('#mySectionRoll', _.wrap)
      mySectionRoll.hide();

      _.setLoadingBar(_.wrap, true);

      getDatasWithOption([{
        type: 'GET',
        url: `${_.option.apiDomain}/api/my/servers`,
        dataType: 'json',
        xhrFields: {withCredentials: true}

      }], (data) => {
        _.setLoadingBar(_.wrap, false);

        const servers = data;
        if (!servers || !Array.isArray(servers) || servers.length <= 0) {
          // no character in servers
          _.setGuide('createCharacter');
          mySectionRoll.show();

        } else {
          // exist character in servers. but, did not set representative character.
          _.setGuide('setRepresentativeCharacter');
          mySectionRoll.show();
        }

      }, (data) => {
        handleApiError(data);

        _.setGuide('retryLater');
        mySectionRoll.show();
      });

    } else {
      // exist representative character.
      _.setRank();
      _.setConnection();
      _.setItem();
      _.setSlick();

      $(_.option.global).on('resize', $.proxy(_.resize, _));

      _.resize();
    }
  }

  setLoadingBar(wrap, flag) {
    $('.loadingbar', wrap).remove();

    if (truthy(flag)) $(wrap).append(getLoadingBarTpl());
  }

  setGuide(type) {
    const _ = this;

    $('.title .btn-myranking', _.wrap).remove();
    $('.title .wrap-myranking', _.wrap).remove();

    $('.section-characteron', _.wrap).remove();
    $('.section-item', _.wrap).remove();

    const wrap = $('#mySectionRoll', _.wrap);

    switch (type) {
      case 'createCharacter' :
        wrap.append(_.tpl.CREATE_CHARACTER(isRc));
        break;

      case 'setRepresentativeCharacter' :
        wrap.append(_.tpl.SET_REPRESENTATIVE_CHARACTER);
        break;

      case 'retryLater' :
        wrap.append(_.tpl.RETRY_LATER);
        break;
    }
  }

  setRank() {
    const _ = this;

    _.rank = new Rank({
      wrap: _.wrap,
      apiDomain: _.option.apiDomain,
      global: _.option.global
    }).init();
  }

  setConnection() {
    const _ = this;

    _.connection = new Connection({
      wrap: $('.section-characteron', _.wrap),
      apiDomain: _.option.apiDomain,
      global: _.option.global
    }).init();
  }

  setItem() {
    const _ = this;

    _.item = new Item({
      wrap: $('.section-item', _.wrap),
      apiDomain: _.option.apiDomain,
      global: _.option.global
    }).init();
  }

  setSlick() {
    this.slickWrap.slick({
      dots: true,
      infinite: false,
      arrows: false,
      speed: 250,
      slidesToShow: 2,
      slidesToScroll: 2,
      responsive: [{
        breakpoint: BREAKPOINTS.tablet,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });
  }

  resize(evt) {
    this.slickWrap.slick('resize');
  }
}

export default My;


// WEBPACK FOOTER //
// ./_src/js/main/my/My.js